












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class MultiSelect extends Vue {
    @Prop({ type: Array, required: true }) items!: Array<any>;
    /** Currently-selected values (matched against item[valueKey]). */
    @Prop({ type: Array, default: () => [] }) value!: Array<any>;
    @Prop({ type: String, default: "val" }) valueKey!: string;
    @Prop({ type: String, default: "label" }) textKey!: string;
    @Prop({ type: String, default: "..." }) defaultMessage!: string;
    @Prop({ type: String, default: "" }) icon!: string;
    @Prop({ type: Boolean, default: false }) inactive!: boolean;
    /** When true, show a text box that filters the list by label (client-side, case-insensitive). */
    @Prop({ type: Boolean, default: false }) searchable!: boolean;
    @Prop({ type: String, default: "Search…" }) searchPlaceholder!: string;

    private selected: Array<any> = [];
    private search: string = "";
    private isActive: boolean = false;
    private componentId: string = "multiselect" + Math.random().toString(36).slice(2, 8);
    private bodyElement: HTMLElement | null = null;

    created() {
        this.selected = [...this.value];
    }

    @Watch("value")
    valueChanged(v: Array<any>) {
        this.selected = [...(v || [])];
    }

    mounted() {
        this.bodyElement = document.querySelector("body");
    }

    /** Placeholder when empty, the single item's label when one is selected, else "N selected". */
    get toggleText(): string {
        if (this.selected.length === 0) return this.defaultMessage;
        if (this.selected.length === 1) {
            const item: any = this.items.find((i: any) => i[this.valueKey] === this.selected[0]);
            if (item) return item[this.textKey];
        }
        return `${this.selected.length} selected`;
    }

    /** The list actually rendered: all items, or (when searching) only labels matching the query. */
    get displayItems(): Array<any> {
        if (!this.searchable || !this.search.trim()) return this.items;
        const query = this.search.trim().toLowerCase();
        // Section headers are meaningless in a filtered list, so drop them while searching.
        return this.items.filter(
            (i: any) => !i.isHeader && String(i[this.textKey] ?? "").toLowerCase().includes(query)
        );
    }

    @Watch("isActive")
    activeChanged(active: boolean) {
        if (!active) {
            this.search = "";
        } else if (this.searchable) {
            this.$nextTick(() => (this.$refs.searchInput as HTMLInputElement | undefined)?.focus());
        }
    }

    private isSelected(item: any): boolean {
        return this.selected.includes(item[this.valueKey]);
    }

    private toggle() {
        if (this.inactive) return;
        this.isActive = !this.isActive;
        if (this.isActive) this.closeOnOuterClick();
    }

    private toggleItem(item: any) {
        const val = item[this.valueKey];
        const idx = this.selected.indexOf(val);
        if (idx >= 0) this.selected.splice(idx, 1);
        else this.selected.push(val);
        this.$emit("change", [...this.selected]);
    }

    private clearAll() {
        this.selected = [];
        this.$emit("change", []);
    }

    private closeOnOuterClick() {
        this.$nextTick(() => {
            const listener = (event: Event) => {
                if (!(event.target as HTMLElement).closest("#" + this.componentId)) {
                    this.isActive = false;
                    this.bodyElement?.removeEventListener("click", listener);
                }
            };
            this.bodyElement?.addEventListener("click", listener);
        });
    }
}
